import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseResetPasswordComponent } from 'src/app/shared/components/base-reset-password/base-reset-password.component';

@Component({
  selector: 'app-sokusai-management-reset-password',
  templateUrl: './sokusai-management-reset-password.component.html',
  styleUrls: ['./sokusai-management-reset-password.component.css', '../style/global.css'],
})
export class SokusaiManagementResetPasswordComponent
  extends BaseResetPasswordComponent
  implements OnInit
{
  errorMessageDict = {
    passwordNotInput: 'パスワードを入力してください。',
    confirmPasswordNotInput: '確認用パスワードを入力してください。',
    passwordNotMatch: 'パスワードが一致しません。',
  };

  inputState = {
    password: { isFocus: false, isShow: false },
    confirmPassword: { isFocus: false, isShow: false },
  };

  constructor(title: Title) {
    super();
    title.setTitle('新しいパスワードを設定');
  }
  ngOnInit(): void {}
}
